module.exports = __webpack_public_path__ + "img/pending.63423625.svg";